import { FormErrors } from "redux-form";

import { ChangePasswordFormData } from "./ChangePasswordForm";
import {
    required,
    equal,
    validEmail,
    validPassword,
} from "../../../util/validators";

const validateChangePasswordForm = (values: ChangePasswordFormData) => {
    const errors: FormErrors<ChangePasswordFormData> = {};
    errors.password = validPassword(values.password);
    errors.verifyPassword = equal(values.password, values.verifyPassword);
    return errors;
};

export default validateChangePasswordForm;



// WEBPACK FOOTER //
// ./src/views/profile/components/ChangePasswordValidator.ts